<template>
  <div style="height:150px;background-color:#424242">
    <v-container style="height:100%">
      <v-row style="height:100%">
        <v-col cols="12" md="4" class="d-flex align-center justify-center justify-md-start">
          <h3 class="white--text">ER | Edgardo Reinoso</h3>
        </v-col>
        <v-col cols="12" md="8" class="d-flex align-center justify-center justify-md-end">
          <div>
            <p class="mb-0 white--text">Connect with me</p>
          </div>
          <div v-for="(item,index) in socialMedia" :key="index" class="pl-5">
            <a
              style="text-decoration:none;"
              :target="item.target ? '_blank': null"
              :href="item.link"
            >
              <v-icon medium dark class="pr-3 icon-hover">{{item.icon}}</v-icon>
            </a>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data: () => ({
    socialMedia: [
      {
        link: "mailto:edgardoreinoso16@gmail.com",
        target: false,
        icon: "mdi-email"
      },
      {
        link: "https://github.com/edreinoso",
        target: true,
        icon: "mdi-github"
      },
      {
        link: "https://www.linkedin.com/in/edgardo-reinoso-135683108/",
        target: true,
        icon: "mdi-linkedin"
      },
      {
        link: "https://twitter.com/EReinoso23",
        target: true,
        icon: "mdi-twitter"
      }
    ]
  })
};
</script>

<style>
.icon-hover:hover {
  color: #979797 !important;
  transition: 200ms ease;
}
</style>